import Cookies from 'js-cookie';


export const setAccessToken = (token, expiry) => Cookies.set('access_token', token, {expires: expiry});
export const setLoggedUser = (userInfo, expiry) => Cookies.set('userInfoTTMS', userInfo, {expires: expiry});
export const updateLoggedUser = (userInfo) => Cookies.set('userInfoTTMS', userInfo);


export const getAccessToken = () => Cookies.get('access_token');
//export const getRefreshToken = () => Cookies.get('refresh_token');
export const isAuthenticated = () => !!getUserInfo();
//export const isAuthenticated = () => !!getAccessToken();

export const getUserInfo = () => {
    if (Cookies.get('userInfoTTMS')){
        return JSON.parse(Cookies.get('userInfoTTMS'));
    }else{
        return null;
    }
};

export const clearCookies = () =>{
    Cookies.remove('access_token');
    Cookies.remove('userInfoTTMS');
    //localStorage.removeItem('userInfo');
};

